import { defineFcm } from '../shared/factory';

export const FCM_STARFISH_MULTIPLE_QRCODE_FLYERS = defineFcm('starfish_multiple_qrcode_flyers')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-starfish',
		scope: 'corgi-front-end',
		context: 'Starter Dashboard page',
		description:
			'Enables the multi flyers modal feature that allows the user to choose and download a qrcode flyer from various templates. This fcm takes precedence over this `starfish_qrcode_flyer` fcm which enables the default qrcode flyer button.',
		import: false,
	});
